import { Download, Loader2 } from "lucide-react";

/* eslint-disable react/prop-types */
export default function Tableheadpanel (props) {

    const {setglobalfilter , isExporting, handleExport,} = props;

    return(
        <div className="flex flex-col md:items-center md:justify-between md:flex-row">
        <div><h2 className="mb-2 text-2xl font-bold md:mb-0">Order Details</h2></div>
        <div className="flex items-center gap-4">
            <div className="relative min-w-64 md:min-w-80">
                <div className="absolute inset-y-0 z-20 flex items-center pointer-events-none start-0 ps-4">
                    <svg className="flex-shrink-0 text-gray-400 size-4 " xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
                </div>
                <input onChange={(e) => setglobalfilter(e.target.value)} type="text" id="icon" name="icon" className="block w-full px-4 py-3 text-sm border border-gray-200 outline-none rounded-xl ps-11 disabled:opacity-50 disabled:pointer-events-none" placeholder="Search Orders ..." />
            </div>
               <button 
          onClick={handleExport}
          disabled={isExporting}
          className={`inline-flex items-center px-3 py-2 text-sm font-medium transition-colors duration-200 bg-regal-yellow border rounded-lg
            ${isExporting 
              ? 'text-gray-400 cursor-not-allowed' 
              : 'text-gray-700 hover:bg-gray-50'
            }`}
        >
          {isExporting ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Exporting...
            </>
          ) : (
            <>
              <Download className="w-4 h-4 mr-2" />
              Export
            </>
          )}
        </button>
        </div>
    </div>
    )
}